export default __webpack_public_path__ + "static/CopernicusWeb-Book-77eceb41dd29a2db1175bcd5ee225ade.woff";